module.exports = require("prismjs/components/prism-swift.js");